<template lang='pug'>
.home
  cms-page
</template>
<script setup lang="ts">
import { useHead } from '@unhead/vue'
import CmsPage from '../cms/cms.vue'
import { useRogue } from '@/js/services/Rogue'

const rogue = useRogue()

const { city, street, region, postcode } = rogue.site.pickup?.address || {}

let siteName = rogue.site.name

let country = 'United States'

if (['EUR', 'GBR'].includes(rogue.site.code)) {
  country = 'Belgium'
  if (rogue.l10n.path) {
    siteName = siteName.replace('Europe', rogue.l10n.country.toUpperCase())
  }
} else if (rogue.site.code === 'AUS') {
  country = 'Australia'
}
const socialLinks = Object.values(rogue.site.social || {})
const rogueReferenceSites = [...socialLinks, 'https://en.wikipedia.org/wiki/Rogue_Fitness']

const knowsAbout = [
  'Fitness',
  'Strength & Conditioning equipment',
  'Gym Equipment',
  'Sports Equipment',
  'Gym Clothes',
]

const ldJSON = {
  '@context'                : 'http://www.schema.org',
  '@type'                   : 'Organization',
  name                      : siteName,
  logo                      : 'https://assets.roguefitness.com/UI/logos/rogue-logo-classic_ifo2pb.svg',
  description               : rogue.__('Rogue Fitness is the leading manufacturer in strength and conditioning equipment & an official sponsor of the CrossFit® Games, Arnold Classic, and USA Weightlifting. From power racks, rigs, and barbells to shoes, apparel and accessories, our online store equips garage gyms, military, pros and more.'),
  disambiguatingDescription : rogue.__('Rogue Fitness is an American manufacturer and distributor of strength and conditioning equipment.'),
  address                   : !city ? undefined : {
    '@type'         : 'PostalAddress',
    streetAddress   : street[0],
    addressLocality : city,
    addressRegion   : region,
    postalCode      : postcode,
    addressCountry  : country,
  },
  contactPoint: {
    '@type'     : 'ContactPoint',
    telephone   : rogue.site.support.phone,
    contactType : 'Customer Service',
  },
  email   : rogue.site.support.email,
  sameAs  : rogueReferenceSites,
  founder : {
    '@type' : 'Person',
    name    : 'Bill Henniger',
  },
  foundingDate     : '2007',
  foundingLocation : {
    '@type' : 'Place',
    address : {
      '@type'         : 'PostalAddress',
      addressLocality : 'Toledo',
      addressRegion   : 'OH',
    },
  },
  numberOfEmployees  : '1000+',
  knowsAbout,
  parentOrganization : {
    '@type' : 'Organization',
    name    : siteName,
    url     : rogue.localizedBaseURL,
  },
  keywords        : knowsAbout,
  subOrganization : siteName,
  alternateName   : siteName,
}

useHead({
  script: [
    {
      type      : 'application/ld+json',
      key       : 'home-ld-json',
      innerHTML : JSON.stringify(ldJSON),
    },
  ],
})
</script>
